import React, { Component } from 'react';

import { loadReCaptchaScript } from '../../utils/loadReCaptchaScript';
import { getEnvironment } from '../../utils/getEnvironment';
import { RECAPTCHA_KEY } from '../../constants';
import './CaptchaField.css';

class CaptchaField extends Component {
    constructor(props) {
        super(props);
        this.captureDiv = null;
        this.setCaptureDivReference = this.setCaptureDivReference.bind(this);
    }

    componentWillUnmount() {
        window.onGCaptchaLoad = null;
    }

    componentDidMount() {
        loadReCaptchaScript();
        const captcha = window.grecaptcha;
        if (captcha) {
            captcha.render && captcha.render(this.captureDiv);
        } else {
            window.onGCaptchaLoad = () => {
                window.grecaptcha.render(this.captureDiv);
            };
        }
    }

    setCaptureDivReference(captureDiv) {
        this.captureDiv = captureDiv;
    }


    render() {
        const {fieldConfig, showValidationError} = this.props;

        return (
                <label className={`CaptchaField-label${showValidationError ? ' CaptchaField-label--error' : ''}`}>
                    <span className="CaptchaField-title">{fieldConfig.label}</span>
                    <div className="CaptchaField-field-box-container">
                        <div className="CaptchaField-field-box">
                            <div
                                    className="g-recaptcha CaptchaField-iframe-container"
                                    data-sitekey={RECAPTCHA_KEY[getEnvironment()]}
                                    data-callback="onCaptchaUpdate"
                                    data-expired-callback="onCaptchaExpire"
                                    ref={this.setCaptureDivReference}
                            >
                                Loading captcha...
                            </div>
                        </div>
                    </div>
                    <span className="CaptchaField-error-msg">{fieldConfig.errorMsg}</span>
                </label>
        );
    }
}

export default CaptchaField;



// WEBPACK FOOTER //
// ./src/components/Form/CaptchaField.js